import { PackImageMikeMo } from '~/client/components/Images'
import { PackType, ROUTE, Series } from '~/interfaces'
import { If } from 'components'
import { motion } from 'framer-motion'
import { useDeviceSize } from '~/client/utils/ScreenSizes'
import {
  BounceInOutAnimation,
  PackSelectionCopyAnimation,
  SlideInFromBottomAnimation,
  SlideInFromLeftAnimation,
} from '../Animations'
import { cx, PackActionButton, PacksDisplayList } from '../PacksList/PacksList'
import { useRouter } from 'next/router'
import { Link } from '../Link'

export const MikeMoNfts = () => {
  const router = useRouter()
  const featuredPacksTextAnimation = useDeviceSize({
    initial: null,
    desktop: SlideInFromLeftAnimation,
    tablet: BounceInOutAnimation,
    mobile: BounceInOutAnimation,
  })

  if (featuredPacksTextAnimation === null) return null
  return (
    <div className={cx('container', 'packs-container')}>
      <If cond={router.pathname === ROUTE.home}>
        <motion.div
          variants={PackSelectionCopyAnimation}
          className={cx('packslist-copy-container')}
        >
          <h2>Fully Flared Digital Packs</h2>
          <p>
            Series 1, Drop 1, contains 33 different moments from Mikemo
            Capaldi&apos;s part in Fully Flared. Including the{' '}
            <strong className='legendary-text'>Legendary </strong> Digital and
            Physical collectible of the Switch Flip Explosion Intro.
          </p>
        </motion.div>
      </If>
      <PacksDisplayList>
        <MikeMoPacks />
      </PacksDisplayList>
    </div>
  )
}

export const MikeMoPacks = () => {
  const packsAnimation = useDeviceSize({
    initial: null,
    desktop: SlideInFromBottomAnimation,
    mobile: SlideInFromBottomAnimation,
    tablet: SlideInFromBottomAnimation,
  })

  if (packsAnimation === null) return null

  return (
    <>
      <motion.div variants={packsAnimation}>
        <PackDisplayMikeMo type={PackType.standard} />
      </motion.div>
      <motion.div variants={packsAnimation}>
        <PackDisplayMikeMo type={PackType.premium} />
      </motion.div>
    </>
  )
}

export const PackDisplayMikeMo = ({ type }: { type: PackType }) => {
  return (
    <>
      <If cond={type === PackType.standard}>
        <div className={cx('pack-display-container')}>
          <Link href={`/packs/${Series.one}/${type.toLowerCase()}`}>
            <PackImageMikeMo type={PackType.standard} />
          </Link>
          <div>
            <h2 className='pack-type'>{PackType.standard} pack</h2>
            <p>Fully Flared | Mikemo Capaldi</p>
            <h3>$9.69</h3>
            <p className='is-small'>0/3000 packs available.</p>
          </div>
          <PackActionButton
            id={0}
            type={PackType.standard}
            price={0}
            available={0}
            total={0}
            series={Series.one}
          ></PackActionButton>
        </div>
      </If>
      <If cond={type === PackType.premium}>
        <div className={cx('pack-display-container')}>
          <Link href={`/packs/${Series.one}/${type.toLowerCase()}`}>
            <PackImageMikeMo type={PackType.premium} />
          </Link>
          <div>
            <h2 className='pack-type'>{PackType.premium} pack</h2>
            <p>Fully Flared | Mikemo Capaldi</p>
            <h3>$42.69</h3>
            <p className='is-small'>0/420 packs available.</p>
          </div>
          <PackActionButton
            id={0}
            type={PackType.premium}
            price={0}
            available={0}
            total={0}
            series={Series.one}
          ></PackActionButton>
        </div>
      </If>
    </>
  )
}
